<template lang="pug">
  d-input-base(
    component="v-autocomplete"
    v-bind="extendAttrs"
    v-on="$listeners"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")
</template>

<script>
import DInputBase from './DInputBase.vue';
import VAutocomplete from 'vuetify/lib/components/VAutocomplete/VAutocomplete';

export default {
  components:  {
    DInputBase,
    VAutocomplete,
  },
  computed: {
    extendAttrs() {
      return {
        placeholder: 'Выберите...',
        appendIcon: '$ui-chevron-down',
        height: 48,
        ...this.$attrs,
      };
    },
  },
};
</script>
